import React from 'react';

const CSelect = ({
  defaultValue,
  onChange,
  name,
  label,
  options,
  error,
  ...rest
}) => {
  return (
    <div className="form-group">
      <div className="form-label-group">
        {/* <label htmlFor={name}>{label}</label> */}
        <select
          defaultValue={defaultValue}
          onChange={onChange}
          name={name}
          id={name}
          {...rest}
          className="form-control"
        >
          <option value="">{label}</option>
          {options}
        </select>
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    </div>
  );
};

export default CSelect;
